/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generate_ButtonInputs */



/**
* | output |
* | --- |
* | "Generate Code" |
*
* @param {Offline_Activation_Generate_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generate_button = /** @type {((inputs?: Offline_Activation_Generate_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generate_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generer le code")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code generieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genera codice")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сгенерировать код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generar código")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コードを生成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड जनरेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerar código")
	return /** @type {LocalizedString} */ ("Generate Code")
});